// Utils
export const getMatchPlayers = (match) => {

    if(match.homeHolders.length > 0 && match.awayHolders.length > 0)
        return match.homeHolders.concat(match.homeSubstitutes).concat(match.awayHolders).concat(match.awaySubstitutes)

    return match.homeTeam.players.concat(match.awayTeam.players)
}

// Utils
export const getMatchTeams = (match) => {

    return [match.homeTeam,match.awayTeam]
}